(function(Drupal, $, once){
    Drupal.behaviors.mo32 = {

        attach() {
            $(once('mo32', '.MO32')).each(function(){
                const $component = $(this);

                // Component form.
                const $form_id = $component.closest( "form" ).attr("id");
                const $MO32_form = $('#' + $form_id);
                // Component multiple dropdowns.
                const $form_dropdowns = $MO32_form.find('.filter_dropdown-js');
                // Component cta buttons.
                const $hidden_submit_btn = $MO32_form.find('input.form__submit--hidden');
                const $form_action = $MO32_form.find('.MO32__actions');
                const $submit_btn = $MO32_form.find('button.MO32__submit');
                const $reset_btn = $form_action.find('.MO32__reset').remove();
                // Component tag elements.
                const $tags_wrapper = $MO32_form.find('.MO32__tag-container-js');
                const $tags_container = $tags_wrapper.find('.MO32__tags-js');
                const tag_class = 'MO32__tag-item';
                const $count_wrapper = $component.find('.MO32__tag-count');
                const $count_message = $component.find('.MO32__tag-count__message');
                let hasTags = false;
                // Component checkbox options.
                const $chkbox_options = $MO32_form.find('.js-form-type-checkbox input, .flag--product input');

                const isMarketingHub = $('.layout-container').hasClass('toolkit-page');

                let total_checked = 0;


                $tags_container.empty();

                // Build the tags from the multiple select checkbox.
                $form_dropdowns.each((index, dropdown) => {

                    // Manage tags count message logic.
                    total_checked = total_checked + $(dropdown).find('.js-form-type-checkbox input:checked, .flag--product input:checked').length;

                    $(dropdown).find('.js-form-type-checkbox, .flag--product').each((index, checkbox) => {

                        const $checkbox = $(checkbox);

                        if ($checkbox.find('input').attr('checked')) {

                            // Append reset button.
                            if (!hasTags) {
                                if (isMarketingHub) {
                                    $reset_btn.attr('type', 'button');
                                    $reset_btn.clone().text('Clear').appendTo($tags_container.parent());
                                    $reset_btn.clone().appendTo($('.MO32__actions'));
                                } else if (total_checked < 10) {
                                    $reset_btn.appendTo($tags_container.parent());
                                } else if (total_checked >= 10) {
                                    $reset_btn.appendTo($count_wrapper);
                                }
                            }

                            hasTags = true;

                            if (total_checked < 10 || isMarketingHub) {
                                $count_wrapper.hide();
                                const tag_text = $checkbox.find('label').text();
                                const tag_id = $checkbox.find('input')[0].id;
                                $('<span />').addClass(tag_class).text(tag_text).attr({'data-id': tag_id, 'tabIndex': '0'}).appendTo($tags_container);
                            }
                        }
                    });

                });

                if (total_checked >= 10 && !isMarketingHub) {
                    $count_wrapper.css('display', 'flex');
                    $('<span />').addClass('count').text(total_checked).prependTo($count_message);
                    // Hide the tags container
                    $tags_container.hide();
                }

                function removeTag(elem) {
                    const tag_id = elem.data('id');

                    elem.remove();

                    $MO32_form.find('.MO32__form').find('#'+tag_id).prop('checked', false);

                    // trigger click event on submit cta
                    // to show loading spin and refresh page.
                    $submit_btn.click();
                }

                // Remove the clicked tag and
                // update the multiple select related checkbox.
                $tags_container.off().on( "click", `.${tag_class}`, function() {
                    removeTag($(this));
                }).on("keyup", `.${tag_class}`, function(event) {
                    const enterKeyCode = 13;
                    if (event.keyCode === enterKeyCode) {
                        removeTag($(this));
                    }
                });

                // Remove all options on clicked reset filters.
                $(document).on("click", ".MO32__reset" , function(e) {

                    if (!isMarketingHub) {
                        e.preventDefault();

                        $chkbox_options.each((index, checkbox) => {
                            $(checkbox).prop('checked', false);
                        });

                        $submit_btn.click();
                    } else {
                        window.location = window.location.pathname;
                    }

                });

                // Remove all filters on clicked tag count.
                $count_message.click(function(e) {
                    $reset_btn.click();
                });

                $submit_btn.click(function(e) {
                    $hidden_submit_btn.click();
                });
            });
        }
    };
})(Drupal, jQuery, once);
